import React from 'react'

import bg  from './../../UI/ingreso/loading/bg.webp'

interface Props{
    isLoading: boolean,
    ArrayLength: any ,
    currentImagesDownloaded: number
}

interface State{}

class LoadingMobile extends React.Component<Props,State>{
    constructor(props: Props){
        super(props);
        this.state = {}
    }

    render(): React.ReactNode {
        return(
            <div className={this.props.isLoading ? 'loading-div-mobile fade-in':'loading-div-mobile fade-out'}>
                <img src={bg}/>
                <div className='loading-gradient-mobile'>
                    <div className='loading-data-mobile'>{Math.floor((this.props.currentImagesDownloaded * 100) / this.props.ArrayLength)} %</div>
                    <div className='loadig-title-mobile'>Bienvenido,</div>
                    <div className='loadig-subtitle-mobile'>por favor espera</div>
                    <div className='loading-circles-mobile'>
                    <svg className="loader-circle-mobile" viewBox="0 0 150 150" xmlns="http://www.w3.org/2000/svg">
                        <circle className= 'internal-circle-mobile' cx="75" cy="75" r="70"></circle>
                    </svg>
                    <svg className="loader-circle-over-mobile" viewBox="0 0 150 150" xmlns="http://www.w3.org/2000/svg">
                        <circle className= 'internal-circle-over-mobile' cx="75" cy="75" r="70"></circle>
                    </svg>
                </div>
                </div>
            </div>
        )
    }
}

export default LoadingMobile